<template>
  <div class="loyalty-wrap">
    <div v-if="status === 'loading'" class="page page--loading" />
    <div v-else-if="status === 'soon'" class="soon-page">
      <img src="@/assets/images/soon.png" alt="Uskoro" class="soon-image" />
    </div>
    <div v-else class="page">
      <div class="page-content">
        <img
          src="@/assets/images/logo_2.png"
          alt="Soccerbet VIP Klub"
          class="logo-main"
        />
        <div class="store-buttons">
          <a
            v-if="platform === 'android' || platform === null"
            href="https://play.google.com/store/apps/details?id=com.sagastartech.etitoapp.soccerbet.rs.prod&pcampaignid=web_share"
            target="_blank"
            rel="noreferrer"
            class="store-button"
          >
            <img
              src="@/assets/images/google_play.png"
              alt="Google Play"
              class="store-button-image"
            />
          </a>
          <a
            v-if="platform === 'ios' || platform === null"
            href="https://apps.apple.com/us/app/soccerbet-rs-vip-club/id6752946557"
            target="_blank"
            rel="noreferrer"
            class="store-button"
          >
            <img
              src="@/assets/images/app_store.png"
              alt="App Store"
              class="store-button-image"
            />
          </a>
        </div>
        <div class="divider-row">
          <span class="divider-line" />
          <span class="divider-text">ili</span>
          <span class="divider-line" />
        </div>
        <div class="web-app-wrapper">
          <a href="https://retail.soccerbet.rs/auth-successful?action=password-changed" class="store-button">
            <img
              src="@/assets/images/web_aplikacija.png"
              alt="Web aplikacija"
              class="store-button-image"
            />
          </a>
        </div>
      </div>
      <a href="javascript:void(0)" class="help-link" style="pointer-events: none; opacity: 0.5;">
        <span class="help-icon" aria-hidden="true">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              d="M10 14H4C3.46667 14 2.93333 13.8 2.6 13.4C2.2 13.0667 2 12.5333 2 12V6C2 5.46667 2.2 4.93333 2.6 4.6C2.93333 4.2 3.46667 4 4 4H7.33333C7.73333 4 8 4.26667 8 4.66667C8 5.06667 7.73333 5.33333 7.33333 5.33333H4C3.8 5.33333 3.66667 5.4 3.53333 5.53333C3.4 5.66667 3.33333 5.8 3.33333 6V12C3.33333 12.2 3.4 12.3333 3.53333 12.4667C3.66667 12.6 3.8 12.6667 4 12.6667H10C10.2 12.6667 10.3333 12.6 10.4667 12.4667C10.6 12.3333 10.6667 12.2 10.6667 12V8.66667C10.6667 8.26667 10.9333 8 11.3333 8C11.7333 8 12 8.26667 12 8.66667V12C12 12.5333 11.8 13.0667 11.4 13.4C11 13.7333 10.5333 14 10 14Z"
              fill="white"
            />
            <path
              d="M6.66667 10C6.46667 10 6.33333 9.93333 6.2 9.8C5.93333 9.53333 5.93333 9.13333 6.2 8.86667L12.8667 2.2C13.1333 1.93333 13.5333 1.93333 13.8 2.2C14.0667 2.46667 14.0667 2.86667 13.8 3.13333L7.13333 9.8C7 9.93333 6.86667 10 6.66667 10Z"
              fill="white"
            />
            <path
              d="M13.3334 6.66667C12.9334 6.66667 12.6667 6.4 12.6667 6V3.33333H10C9.60004 3.33333 9.33337 3.06667 9.33337 2.66667C9.33337 2.26667 9.60004 2 10 2H13.3334C13.7334 2 14 2.26667 14 2.66667V6C14 6.4 13.7334 6.66667 13.3334 6.66667Z"
              fill="white"
            />
          </svg>
        </span>
        <span class="help-text">Uputstvo za korisnike</span>
      </a>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue } from "vue-class-component";
import { LOYALTY_API_BASE } from "@/config/urls";

function getPlatform(): "ios" | "android" | null {
  const ua = navigator.userAgent || (navigator as unknown as { vendor?: string }).vendor || "";
  if (/iPhone|iPad|iPod/i.test(ua)) return "ios";
  if (/Android/i.test(ua)) return "android";
  return null;
}

export default class Scan extends Vue {
  platform: "ios" | "android" | null = getPlatform();
  status: "loading" | "main" | "soon" = "loading";

  mounted() {
    const params = new URLSearchParams(window.location.search);
    const gmId = params.get("gm_id");

    fetch(`${LOYALTY_API_BASE}/codes`)
      .then((res) => res.json())
      .then((codes: unknown) => {
        const validCodes = Array.isArray(codes) ? codes : [];
        const isAllowed = gmId && validCodes.includes(gmId);

        if (isAllowed && gmId) {
          this.status = "main";
          fetch(`${LOYALTY_API_BASE}/create-scan`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ gm_id: gmId }),
          }).catch((err) => console.error("Greška pri slanju create-scan zahteva", err));
        } else {
          this.status = "soon";
        }
      })
      .catch(() => {
        this.status = "soon";
      });
  }
}
</script>

<style scoped>
.loyalty-wrap {
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "SF Pro Text", Helvetica, Arial, sans-serif;
  line-height: 1.5;
  font-weight: 400;
  color: #ffffff;
  background:
    radial-gradient(
      56.27% 56.24% at 50% 41.79%,
      rgba(134, 126, 205, 0.44) 0%,
      rgba(49, 46, 55, 0.44) 69.41%,
      rgba(0, 0, 0, 0.44) 100%
    ),
    linear-gradient(
      0deg,
      rgba(68, 71, 80, 0.2) 0%,
      rgba(68, 71, 80, 0.2) 100%
    ),
    linear-gradient(180deg, #454545 0%, #272727 100%);
  min-height: 100vh;
  min-width: 320px;
}

.page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 32px 16px 24px;
}

.page--loading {
  min-height: 100vh;
}

.soon-page {
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.soon-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
}

.page-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  width: 100%;
  max-width: 360px;
}

.logo-main {
  width: 100%;
  max-width: 180px;
  height: auto;
  display: block;
  margin-top: 24px;
}

.store-buttons {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  align-items: center;
}

.store-button-image {
  width: 100%;
  max-width: 220px;
  height: auto;
  display: block;
}

.divider-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: #dddddd;
  font-size: 14px;
}

.divider-line {
  width: 87.5px;
  height: 1px;
  background: #dddddd;
  flex-shrink: 0;
}

.divider-text {
  text-transform: lowercase;
}

.web-app-wrapper {
  margin-top: 8px;
  width: 100%;
  display: flex;
  justify-content: center;
}

.help-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #ffffff;
  opacity: 0.9;
  text-decoration: underline;
}

.help-link:hover {
  opacity: 1;
}

.help-icon {
  width: 16px;
  height: 16px;
  display: inline-flex;
}

.help-icon svg {
  width: 16px;
  height: 16px;
}
</style>
